import { createAction, props } from '@ngrx/store';
import { User } from 'src/app/shared/models/user.model';

export const addItem = createAction('[Item] Add',
    props<{ name: string, last_name: string }>());
export const getAllItems = createAction('[Item] Get All');
export const deleteItem = createAction('[Item] Delete',
    props<{ id: number }>());
export const updateItem = createAction('[Item] Update',
    props<{ user: User }>());
